import { createFileRoute, Outlet } from "@tanstack/react-router";

import React from "react";
import { useTranslation } from "react-i18next";
import TabLayout from "src/components/base/tab-layout";
import SINGLE_GROUP_CONTEXT, { SingleGroupProvider } from "src/context/customer/group";
import { Tab, TabMenu } from "src/components/base/tab-menu";
import { BackButton } from "src/components/base/button";

/**
 * The properties for {@link SingleGroup}
 */
export type SingleGroupProps = {};

/**
 * The menu for a single group
 */
function SingleGroup(props: SingleGroupProps) {
    const [t] = useTranslation("customer-group-view");

    const { groupId } = Route.useParams();

    return (
        <SingleGroupProvider uuid={groupId}>
            <SINGLE_GROUP_CONTEXT.Consumer>
                {(ctx) => (
                    <div className={"flex flex-col gap-6"}>
                        <BackButton className={"self-start"} href={"/c/groups/local"}>
                            {t("button.back-to-group-overview")}
                        </BackButton>
                        <TabLayout
                            tabs={
                                <TabMenu>
                                    <Tab href={"/c/groups/$groupId/general"}>{t("label.general")}</Tab>
                                    <Tab href={"/c/groups/$groupId/inbound-acls"}>{t("label.inbound-acls")}</Tab>
                                    <Tab href={"/c/groups/$groupId/outbound-acls"}>{t("label.outbound-acls")}</Tab>
                                </TabMenu>
                            }
                            heading={t("heading.group", { group: ctx.group.name })}
                            headingDescription={ctx.group.description}
                        >
                            <Outlet />
                        </TabLayout>
                    </div>
                )}
            </SINGLE_GROUP_CONTEXT.Consumer>
        </SingleGroupProvider>
    );
}

export const Route = createFileRoute("/_customer/c/groups/$groupId/_group")({
    component: SingleGroup,
});
